import styled from 'styled-components';
import { color } from '~/assets/styles/colors';

export const Table = styled.table`
	width: 100%;
	font-size: 12px;
	tr {
		height: 40px;
		border-bottom: 1px solid ${color.grayMedium};

		th,
		td {
			padding: 0 10px;
		}

		&:last-child {
			border-bottom: 0;
		}
	}
`;
